function getAccountRegion(session) {
  const account = (session?.accounts ?? []).find(
    (a) => a.id === session?.currentAccountId
  )?.agencies?.data?.[0];

  return account?.address?.country?.id;
}

export { getAccountRegion };
